import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    GET_VIRTUAL_POS,
    GET_VIRTUAL_POS_SUCCESS,
    GET_VIRTUAL_POS_ERROR,
}
    from "../../actions/payment"

function* getVirtualPosSaga(action) {
    try {
       const data  = yield call(paymentService.GetVirtualPOS,action.payload)
       yield put({
        type: GET_VIRTUAL_POS_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: GET_VIRTUAL_POS_ERROR,error: error.data
        })
    }
}


export function* getVirtualPosSagaWatcher() {
    yield takeLatest(GET_VIRTUAL_POS, getVirtualPosSaga)
}